import * as React from "react";

const SvgMxf = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 25 24"
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.739 10.52h1.804V1.326c0-.18.146-.327.326-.327h11.906c.09 0 .173.037.232.097l3.178 3.178a.33.33 0 0 1 .096.231v6.013h1.804c.18 0 .327.146.327.327v8.677c0 .18-.147.327-.327.327h-1.804v2.717c0 .18-.146.327-.327.327H4.87a.327.327 0 0 1-.326-.327V19.85H2.739a.327.327 0 0 1-.327-.327v-8.677c0-.18.146-.327.327-.327m16.889 0H5.196V1.653h11.252v1.262c0 .528.215 1.007.563 1.354a1.9 1.9 0 0 0 1.353.563h1.264zm.326 8.677h1.804v-8.024H3.065v8.024h16.889m-.326.653H5.196v2.39h14.432zM17.102 2.116v.8c0 .347.142.663.37.892.23.23.545.371.892.371h.801zM6.637 17.258v-4.147H7.89l.752 2.83.744-2.83h1.256v4.147h-.778v-3.264l-.823 3.264h-.806l-.821-3.264v3.264zm4.415 0 1.418-2.164-1.285-1.983h.979l.832 1.333.814-1.333h.97l-1.29 2.014 1.418 2.133h-1.01l-.92-1.434-.922 1.434zm4.291 0v-4.147h2.844v.702H16.18v.981h1.732v.702H16.18v1.762zM7.128 5.072c0-.18.147-.326.327-.326h7.04a.327.327 0 1 1 0 .653h-7.04a.327.327 0 0 1-.327-.327m.327 1.476a.327.327 0 0 0 0 .654h9.913a.327.327 0 0 0 0-.654zm-.327 2.13c0-.181.147-.327.327-.327h9.913a.327.327 0 0 1 0 .653H7.455a.327.327 0 0 1-.327-.327"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMxf;
